import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export interface AlertBoardFilterTheme {
  container: {
    backgroundColor: string;
    borderRadius: string;
    boxShadow: string;
  };
  filterButton: {
    backgroundColor: string;
    iconColor: string;
    textColor: string;
  };
  dropdown: {
    backgroundColor: string;
    labelColor: string;
    valueColor: string;
    iconColor: string;
  };
}

export const alertBoardFilterTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        backgroundColor: theme.color.surface[3],
        borderRadius: '100px',
        boxShadow:
          '0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1), inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1)',
      },
      filterButton: {
        backgroundColor: 'transparent',
        iconColor: theme.color.text.core['-primary'],
        textColor: theme.color.text.core['-primary'],
      },
      dropdown: {
        backgroundColor: 'transparent',
        labelColor: theme.color.text.core['-secondary'],
        valueColor: theme.color.text.core['-emphasis'],
        iconColor: theme.color.text.core['-primary'],
      },
    },
  ]),
);
